import React, { useEffect } from 'react'
import './index.scss'
import { useBreakpointContext } from '../../util/BreakpointProvider'
import { SectionHeader } from '../Headlines'

export function ColorUnderwater({ content }) {
  const { isMobile } = useBreakpointContext();

  // Preload images
  useEffect(() => {
    const images = [
      `assets/expeditionspage/color-underwater/color-underwater-${isMobile ? "mobile" : "desktop"}.png`,
    ];
    images.forEach(image => {
      const img = new Image();
      img.src = image;
    });
  }, [isMobile]);

  return (
    <section className='inset no-border color-underwater'>
      <SectionHeader title="Color Underwater" topBorder />
      <div className="image">
        <img src={`assets/expeditionspage/color-underwater/color-underwater-${isMobile ? "mobile" : "desktop"}.png`} alt="Color underwater" />
      </div>
    </section>
  )
} 